export const ENV_ENDPOINT_VNF = "https://vnf-api.dev.variosecure.com";

export const ENV_ENDPOINT_GAE = "https://device-api.dev.variosecure.com";

export const ENV_DOMAIN_VDAP = "https://pd2.dataprotection.jp";

export const ENV_CP_MSS = "https://dali.dev.variosecure.com/";

export const ENV_URL_KISHIN = "https://kishin-monitor.heroz.jp/vsr";

export const ENV_CONFIG = {
  apiKey: "AIzaSyAIpO6S9YKzgds30tINYeAOE0TgBkdWRJg",
  authDomain: "azumino-dev-fcd1e.firebaseapp.com",
  databaseURL: "https://azumino-dev-fcd1e.firebaseio.com",
  projectId: "azumino-dev-fcd1e",
  storageBucket: "azumino-dev-fcd1e.appspot.com",
  messagingSenderId: "552644705829",
  appId: "1:552644705829:web:03a0536e7446c3a8e449cc",
  measurementId: "G-KW30189N3F",
};
